import { render, staticRenderFns } from "./PackageEditor.vue?vue&type=template&id=4a2128bb"
import script from "./PackageEditor.vue?vue&type=script&lang=js"
export * from "./PackageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports